import * as React from "react";
import { forwardRef } from "react";
const SvgDisabledRadioBtn = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7.25, fill: "#F2F4F7", stroke: "#C2CCD6", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgDisabledRadioBtn);
export default ForwardRef;
